<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 共通情報 -->
      <div :style="{ height: basicHeight + 'px' }">
        <t-form
          :model="numberEditForm"
          label-position="right"
          :label-width="$t('widgetSize.ACCEPT_ORDER_INFO.DETIAL_LABEL_WIDTH')"
        >
          <t-row>
            <t-col :span="colArr.colL">&nbsp;</t-col>
            <!-- 見積No -->
            <t-col :span="colArr.colCom">
              <t-form-item :label="$t('resource.NUMBER.QUOTE_NO')">
                <t-input v-model="numberEditForm.nbQuoteNo" disabled> </t-input>
              </t-form-item>
            </t-col>
            <!-- 見積日 -->
            <t-col :span="colArr.colCom">
              <t-form-item :label="$t('resource.NUMBER.QUOTE_DATE')">
                <t-date-picker
                  v-model="numberEditForm.nbQuoteDate"
                  class="dialogDate"
                  :clearable="false"
                  type="date"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  :editable="false"
                ></t-date-picker>
              </t-form-item>
            </t-col>

            <!-- 得意先 -->
            <t-col :span="colArr.colCom">
              <t-form-item :label="$t('resource.NUMBER.CUSTOMER')">
                <t-input
                  v-model="numberEditForm.nbCusCode"
                  :placeholder="$t('message.NUMBER.CLICK_AND_SELECT_HINT')"
                  disabled
                  @click.native="customerReferenceClick"
                >
                </t-input>
              </t-form-item>
            </t-col>

            <!-- 得意先担当者 -->
            <t-col :span="colArr.colCom">
              <t-form-item :label="$t('resource.NUMBER.CUS_USER')">
                <t-select
                  v-model="numberEditForm.nbCusUserCode"
                  style="width: 100%"
                  placeholder=""
                >
                  <t-option
                    v-for="item in cusUserList"
                    :key="item.mgrCode"
                    :label="item.mgrAbbreviation"
                    :value="item.mgrCode"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <t-col :span="colArr.colR">&nbsp;</t-col>
          </t-row>
          <t-row>
            <t-col :span="colArr.colL">&nbsp;</t-col>
            <!-- 担当者 -->
            <t-col :span="colArr.colCom">
              <t-form-item :label="$t('resource.NUMBER.CONTACTER')">
                <t-select
                  v-model="numberEditForm.nbUserCode"
                  :disabled="!estimateRequestOutputButtonFlg"
                  style="width: 100%"
                >
                  <t-option
                    v-for="item in userList"
                    :key="item.UserId"
                    :label="item.UserName"
                    :value="item.UserId"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <!-- 状態 -->
            <t-col :span="colArr.colCom" class="col_common_searchKey">
              <t-form-item :label="$t('resource.NUMBER.QUOTE_STATE')">
                <t-select
                  v-model="numberEditForm.nbQuoteState"
                  style="width: 100%"
                >
                  <t-option
                    v-for="item in nbStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <!-- 製品情報 -->
      <div>
        <t-row>
          <t-col>
            <div class="div_common_search">
              <div style="padding: 0 15px 15px 15px">
                <t-divider>{{ $t("resource.NUMBER.PRODUCT_INFO") }}</t-divider>
                <t-row>
                  <t-col :span="6" class="col_common_left">
                    <!-- 追加製品行数 -->
                    <t-select
                      v-model="addRowCount"
                      style="width: 80%"
                      class="addRowCount"
                      :disabled="productNotEditFlg"
                    >
                      <t-option
                        v-for="item in addRowCountList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                    <!-- 製品追加ボタン -->
                    <t-button
                      round
                      type="primary"
                      style="margin-left: 10%; margin-right: 10%"
                      class="dialogButton_120_40"
                      ref="productAddBtn"
                      :disabled="productNotEditFlg"
                      @click="productAddClick()"
                    >
                      <i class="el-icon-plus"></i
                      >{{ $t("resource.NUMBER.PRODUCT_ADD_BUTTON") }}
                    </t-button>
                  </t-col>
                  <t-col :span="18" class="col_common_left">
                    <!-- 製品削除ボタン -->
                    <t-button
                      round
                      type="danger"
                      class="dialogButton_120_40"
                      ref="productDelBtn"
                      :disabled="productNotEditFlg"
                      @click="productDeleteClick()"
                    >
                      <i class="el-icon-delete"></i
                      >{{ $t("resource.NUMBER.PRODUCT_DELETE_BUTTON") }}
                    </t-button></t-col
                  >
                </t-row>
                <!-- 製品情報のテーブル -->
                <div>
                  <t-table
                    ref="supplierTable"
                    :data="supplierTable"
                    class="table_common"
                    header-cell-class-name="bg-default"
                    :height="detailHeight"
                    highlight-current-row
                    :cell-class-name="tableCellClassName"
                    border
                  >
                    <!-- 選択ボックス -->
                    <t-table-column
                      type="selection"
                      align="center"
                      header-align="center"
                      :selectable="getSelectable"
                    />
                    <!-- v-if="!productNotEditFlg" -->
                    <!-- テーブルの列 -->
                    <t-table-column
                      v-for="(column, index) in supplierTableColumns"
                      :key="index"
                      :type="column.type"
                      :prop="column.prop"
                      :label="column.label"
                      :min-width="column.width"
                      :class-name="column.class"
                      :show-overflow-tooltip="column.overflowTooltip"
                    >
                      <template slot-scope="scope">
                        <t-input
                          class="cell_input"
                          v-if="editCellData(scope.row, column) == 'input'"
                          :maxLength="column.maxLength"
                          v-model="scope.row[column.prop]"
                          @blur="changeCellData()"
                          :ref="`input${scope.row.index}-${scope.column.property}`"
                          @keyup.native.enter="
                            focusNextInput(
                              scope.row.index,
                              scope.column.property
                            )
                          "
                        />
                        <t-input-number
                          class="cell_input_number"
                          v-else-if="
                            editCellData(scope.row, column) == 'inputNumber'
                          "
                          :controls="false"
                          :precision="column.precision || 0"
                          :min="0"
                          :max="column.max || 999999"
                          v-model="scope.row[column.prop]"
                          @blur="changeCellData()"
                          :ref="`input${scope.row.index}-${scope.column.property}`"
                          @keyup.native.enter="
                            focusNextInput(
                              scope.row.index,
                              scope.column.property
                            )
                          "
                        />
                        <span v-else>
                          {{ scope.row[column.prop] }}
                        </span>
                      </template>
                    </t-table-column>
                  </t-table>
                </div>
              </div>
            </div>
          </t-col>
        </t-row>
      </div>

      <!-- ボタン -->
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row>
          <t-col :span="4" class="col_common_left">
            <!-- 仕入先見積依頼ボタン -->
            <t-button
              round
              type="primary"
              class="dialogButton_180_40"
              ref="showProcessingBtn"
              :disabled="estimateRequestOutputButtonFlg"
              @click="showNumberEditProcessingDialogProc"
            >
              <i class="el-icon-s-order"></i
              >{{ $t("resource.NUMBER.SUPPLIER_ESTIMATE_VIEW") }}
            </t-button></t-col
          >
          <t-col :span="3" class="col_common_left">
            <!-- 得意先見積ボタン -->
            <t-button
              round
              type="primary"
              class="dialogButton_150_40"
              ref="showCustomerBtn"
              :disabled="!supplierCheckResult"
              @click="showNumberEditCustomerDialogProc"
            >
              <i class="el-icon-s-order"></i
              >{{ $t("resource.NUMBER.CUSTOMER_ESTIMATE_VIEW") }}
            </t-button></t-col
          >

          <t-col :span="14" class="right">
            <!-- 再度見積ボタン -->
            <t-button
              round
              type="primary"
              class="dialogButton_120_40"
              ref="estimateAgainBtn"
              :disabled="estimateRequestOutputButtonFlg"
              @click="estimateAgainProc"
            >
              <i class="el-icon-s-order"></i
              >{{ $t("resource.NUMBER.QUOTE_AGAIN_BUTTON") }}
            </t-button>
          </t-col>

          <t-col :span="3" class="right">
            <!-- 確定ボタン -->
            <t-button
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              ref="confirmBtn"
              @click="confirmClick()"
            >
              <i class="el-icon-check"></i>
              {{ $t("resource.sys.sure") }}
            </t-button>
          </t-col>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import {
  ShowCustomerReferenceDialog,
  ShowNumberEditCustomerDialog,
  ShowNumberEditProcessingDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import {
  addNumberInfo,
  editNumberInfo,
  estimateAgain,
  initNumberDetailCusUserList,
  initNumberDetailList,
  searchNumberDetailByNbQuoteNo,
} from "@/services/number";
import {
  cmpBasicData,
  cmpDetailData,
  formatDateStrToString,
  getAbleCusUserInfoList,
  getAbleUserInfoList,
  getCurrentDate,
  getDialogContentHeight,
  getEditColWidthArr,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  NB_ORDER_STATE_NOT_ORDERED,
  NB_ORDER_STATE_ORDERED,
  STR_EMPTY,
} from "@/utils/const";
//import { setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //比較用基本情報
      cmpBasicResult: {},
      //比較用明細情報
      cmpDetailResult: {},

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 2,
      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 2,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT + 10 + 15 + 24
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      numberEditForm: {
        nbQuoteNo: STR_EMPTY,
        nbQuoteDate: STR_EMPTY,
        nbCusCode: STR_EMPTY,
        nbCusUserCode: STR_EMPTY,
        nbUserCode: STR_EMPTY,
        nbQuoteState: STR_EMPTY,
        nbProcKbn: STR_EMPTY,
      },

      //見積状態
      nbStatusList: [],
      //得意先担当者
      cusUserList: [],
      //担当者
      userList: [],
      //追加製品行数
      addRowCountList: [],
      //追加製品行数のデフォルト値
      addRowCount: "1",

      //true:「再度見積」を表示しない、[担当者」をクリックできる、「仕入先見積依頼ボタン]をクリックできない;
      //false:「再度見積」を表示する、[担当者」をクリックできない、「仕入先見積依頼ボタン]をクリックできる;
      estimateRequestOutputButtonFlg: true,

      //true:「製品追加」と「製品削除」をクリックできない、製品情報を編集できない；false:「製品追加」と「製品削除」をクリックできる、製品情報を編集できる
      productNotEditFlg: false,

      //製品情報のテーブル
      supplierTable: [
        {
          ndProdName: STR_EMPTY,
          ndProdDrawNo: STR_EMPTY,
          ndProdQuantity: undefined,
          ndProdUnit: STR_EMPTY,
          ndProdShape: STR_EMPTY,
          ndProdMaterial: STR_EMPTY,
          ndProdTreatment: STR_EMPTY,
          //ndUWeight: undefined,
        },
      ],
      //テーブルのデータのバックアップ
      oldSupplierTableData: null,

      //製品情報のテーブルの列
      supplierTableColumns: [
        {
          prop: "ndProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          class: "cell_txt_left",
          maxLength: 20,
          overflowTooltip: true,
        },
        {
          prop: "ndProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          class: "cell_txt_left",
          maxLength: 30,
          overflowTooltip: true,
        },
        {
          prop: "ndProdQuantity",
          label: t("resource.COMMON_CONSTANT.COUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },
        {
          prop: "ndProdUnit",
          label: t("resource.COMMON_CONSTANT.UNIT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          maxLength: 10,
          overflowTooltip: true,
        },
        {
          prop: "ndProdShape",
          label: t("resource.COMMON_CONSTANT.SHAPE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          maxLength: 20,
          overflowTooltip: true,
        },
        {
          prop: "ndProdMaterial",
          label: t("resource.COMMON_CONSTANT.MATERIAL"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          maxLength: 50,
          overflowTooltip: true,
        },
        {
          prop: "ndProdTreatment",
          label: t("resource.COMMON_CONSTANT.TREATMENT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          maxLength: 50,
          overflowTooltip: true,
        },
        // {
        //   prop: "ndUWeight",
        //   label: t("resource.NUMBER.U_WEIGHT"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        //   precision: 3,
        //   max: 99999.999,
        // },
      ],

      //新規フラグ　true:新規
      localIsAdd: this.isAdd,
      //データの更新時刻
      nbUpdateTime: null,
      //「仕入先」を選択したのチェックの結果  true:チェックに合格する
      supplierCheckResult: false,

      //カバー層のフラップ false:表示しない
      showFlag: false,
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    rowData: {
      Type: Object,
    },
  },

  mounted() {
    this.init(this.rowData);
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  watch: {
    "numberEditForm.nbQuoteNo"(value) {
      //見積No.が空の場合、再度見積ボタンが使用不可
      if (value == STR_EMPTY) {
        this.estimateRequestOutputButtonFlg = true;
      } else {
        this.estimateRequestOutputButtonFlg = false;
      }
    },
    productNotEditFlg(newVal) {
      this.updateTableHeaderCheckboxVisibility();
    },
  },

  methods: {
    // 初期化
    init(data) {
      this.showFlag = true;
      this.infoInit(data);
      //列幅に自動調整
      //(this.supplierTableColumns, this.supplierTable);
    },

    //採番情報の初期化
    infoInit(data) {
      //基本情報のリスト取得（担当者、見積状態）
      initNumberDetailList()
        .then((res) => {
          this.$nextTick(() => {
            //担当者
            this.userList = [];
            res.userList.forEach((item) => {
              this.userList.push({
                UserName: item.UserName,
                UserId: item.UserId,
                Contraction: item.Contraction,
                DeleteFlg: item.DeleteFlg,
              });
            });

            //見積状態
            this.nbStatusList = res.nbStatusList;

            //追加製品行数
            this.addRowCountList = res.addRowCountList;

            //初期値の設定
            this.setInitValue(data);
          });
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        });
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 2,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT + 10 + 15 + 24
      );

      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    //ヘッダのcheckboxが表示されているかどうかを判断する
    updateTableHeaderCheckboxVisibility() {
      if (this.productNotEditFlg) {
        // クラス名を追加してチェックボックスを非表示にする
        this.$el
          .querySelector(".table_common")
          .classList.add("hide-header-checkbox");
      } else {
        // クラス名を削除してチェックボックスを表示
        this.$el
          .querySelector(".table_common")
          .classList.remove("hide-header-checkbox");
      }
    },

    //テーブルの値の取得
    getTableValue(table) {
      var columnList = this.supplierTableColumns.map((column) => column.prop);

      var newData = [];
      for (var i = 0; i < table.length; i++) {
        var newRow = [];
        for (var j = 0; j < columnList.length; j++) {
          newRow.push(table[i][columnList[j]]);
        }
        //newData.push(newRow);
        newData[i] = newRow;
      }
      return JSON.stringify(newData);
    },

    //検索
    searchNumberDetailByNbQuoteNoProc() {
      //見積No.による採番詳細情報の取得
      searchNumberDetailByNbQuoteNo({
        numberEditForm: this.numberEditForm,
      })
        .then((res) => {
          //見積No.
          this.numberEditForm.nbQuoteDate = res.numberEditForm.nbQuoteDate;

          //日付の変換
          if (res.numberEditForm.nbQuoteDate) {
            //見積日
            this.numberEditForm.nbQuoteDate = formatDateStrToString(
              res.numberEditForm.nbQuoteDate
            );
          }

          // 担当者
          if (res.numberEditForm.nbUserCode) {
            this.numberEditForm.nbUserCode = this.userList.find(
              (user) => user.UserId === res.numberEditForm.nbUserCode
            )?.UserId;
          } else {
            this.numberEditForm.nbUserCode = getUserInfo().UserId;
          }

          this.getAbleList();

          //見積状態
          this.numberEditForm.nbQuoteState = this.nbStatusList.find(
            (it) => it.value === res.numberEditForm.nbQuoteState
          )?.value;

          this.nbUpdateTime = res.nbUpdateTime;
          this.supplierCheckResult = res.supplierCheckResult;
          this.productNotEditFlg =
            res.numberEditForm.nbOrderState == NB_ORDER_STATE_ORDERED
              ? true
              : false;
          this.numberEditForm.nbProcKbn = res.numberEditForm.nbProcKbn;
          this.supplierTable = res.supplierTable;
          this.oldSupplierTableData = this.getTableValue(this.supplierTable); //バックアップデータ

          this.dataProcess();
          // setColumnWidth(this.supplierTableColumns, this.supplierTable);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    dataProcess() {
      if (this.localIsAdd) {
        //比較用詳細情報
        this.cmpDetailResult = this.getTableValue(this.supplierTable);
      } else {
        //比較用基本情報
        this.cmpBasicResult = JSON.parse(JSON.stringify(this.numberEditForm));
        //比較用詳細情報
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.oldSupplierTableData)
        );
      }
    },
    //初期値の設定
    setInitValue(data) {
      //新規の場合
      if (this.localIsAdd) {
        //見積日:システム日
        this.numberEditForm.nbQuoteDate = getCurrentDate(new Date());
        //担当者
        this.numberEditForm.nbUserCode = getUserInfo().UserId;
        this.getAbleList();
        //見積状態:新規
        this.numberEditForm.nbQuoteState = this.nbStatusList[0].value;
        this.dataProcess();
        this.showFlag = false;
      }
      //編集の場合
      else {
        //見積No.
        this.numberEditForm.nbQuoteNo = data.nbQuoteNo;

        //得意先
        this.numberEditForm.nbCusCode = data.nbCusCode;

        //基本情報のリスト取得（得意先担当者）
        initNumberDetailCusUserList({
          numberEditForm: this.numberEditForm,
        })
          .then((res) => {
            this.$nextTick(() => {
              //得意先担当者リストに追加
              this.cusUserList = [];
              res.cusUserList.forEach((item) => {
                this.cusUserList.push({
                  mgrCode: item.mgrCode,
                  mgrAbbreviation: item.mgrAbbreviation,
                  mgrDelFlag: item.mgrDelFlag,
                });
              });

              //得意先担当者
              this.numberEditForm.nbCusUserCode = this.cusUserList.find(
                (cu) => cu.mgrAbbreviation === data.nbCusUserCode
              )?.mgrCode;
            });

            this.searchNumberDetailByNbQuoteNoProc();
          })
          .catch(() => {
            this.showFlag = false;
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(
                t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
              );
            }
          });
      }
    },

    // 使用可能な担当者リスト、得意先担当者リストの取得
    getAbleList() {
      // 担当者リスト
      this.userList = getAbleUserInfoList(
        this.userList,
        this.numberEditForm.nbUserCode
      );

      //得意先担当者リスト
      this.cusUserList = getAbleCusUserInfoList(
        this.cusUserList,
        this.numberEditForm.cusCode
      );
    },

    //参照ボタン
    customerReferenceClick() {
      var arr = this.numberEditForm.nbCusCode.split(":");
      var cusCode = arr.length > 0 ? arr[0] : STR_EMPTY;

      //編集の場合、処理を行わない
      if (!this.localIsAdd) {
        return;
      }

      ShowCustomerReferenceDialog(
        { cusCode: cusCode },
        t("resource.NUMBER.CUSTOMER_REFERENCE_VIEW"),
        (target) => {
          if (target) {
            this.numberEditForm.nbCusCode = target;
            //基本情報のリスト取得（得意先担当者）
            initNumberDetailCusUserList({
              numberEditForm: this.numberEditForm,
            })
              .then((res) => {
                this.cusUserList = [];
                this.$nextTick(() => {
                  if (res.cusUserList.length > 0) {
                    //得意先担当者リストに追加
                    res.cusUserList.forEach((item) => {
                      this.cusUserList.push({
                        mgrCode: item.mgrCode,
                        mgrAbbreviation: item.mgrAbbreviation,
                        mgrDelFlag: item.mgrDelFlag,
                      });
                    });
                    this.getAbleList();

                    if (this.cusUserList.length > 0) {
                      //得意先担当者
                      this.numberEditForm.nbCusUserCode =
                        this.cusUserList[0].mgrCode;
                    } else {
                      this.numberEditForm.nbCusUserCode = STR_EMPTY;
                    }
                  } else {
                    this.numberEditForm.nbCusUserCode = STR_EMPTY;
                  }
                });
              })
              .catch((err) => {
                this.showFlag = false;
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(
                    t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
                  );
                }
              });
          }
        }
      );
    },

    //製品追加ボタン
    productAddClick() {
      for (var x = 0; x < Number(this.addRowCount); x++) {
        var newObject = {};

        for (var i = 0; i < this.supplierTableColumns.length; i++) {
          if (this.supplierTableColumns[i].prop == "ndProdQuantity") {
            newObject[this.supplierTableColumns[i].prop] = undefined;
          } else {
            newObject[this.supplierTableColumns[i].prop] = null;
          }
        }

        this.supplierTable.push(newObject);
      }

      // フォーカス削除
      this.$refs.productAddBtn.$el.blur();
    },

    //製品削除ボタン
    productDeleteClick() {
      //「削除行」の索引
      var indexToDelete = [];
      for (var i = 0; i < this.$refs.supplierTable.selection.length; i++) {
        indexToDelete.push(this.$refs.supplierTable.selection[i].index);
      }

      if (this.$refs.supplierTable.selection.length >= 1) {
        Modal.showWarning("", t("resource.sys.deleteMessage"), {
          $type: "prompt",
          confirmButtonText: t("resource.button.sure"),
          cancelButtonText: t("resource.button.cancel"),
          showCancelButton: true,
        }).then(() => {
          //削除行
          indexToDelete
            .sort((a, b) => b - a)
            .forEach((index) => {
              if (index < this.supplierTable.length) {
                this.supplierTable.splice(index, 1);
              }
            });
        });
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      // フォーカス削除
      this.$refs.productDelBtn.$el.blur();
    },

    //セルの編集
    editCellData(row, column, cell, event) {
      //受注済みの場合、製品編集不可
      if (this.productNotEditFlg) {
        return false;
      }

      if (
        column.prop == "ndProdName" ||
        column.prop == "ndProdDrawNo" ||
        column.prop == "ndProdUnit" ||
        column.prop == "ndProdMaterial" ||
        column.prop == "ndProdTreatment" ||
        column.prop == "ndProdShape"
      ) {
        return "input";
      } else if (
        column.prop == "ndProdQuantity"
        //||column.prop == "ndUWeight"
      ) {
        return "inputNumber";
      } else {
        return false;
      }
    },

    //セルの保存
    changeCellData() {
      //setColumnWidth(this.supplierTableColumns, this.supplierTable);
    },

    //確定ボタン
    confirmClick() {
      //入力チェック
      if (this.inputCheck()) {
        //新規の場合、見積Noを設定する
        if (this.localIsAdd) {
          //見積Noの設定 (例：X-120-)
          this.numberEditForm.nbQuoteNo =
            this.getContraction(this.numberEditForm.nbUserCode) +
            "-" +
            this.numberEditForm.nbCusCode.substring(
              0,
              this.numberEditForm.nbCusCode.indexOf(":")
            ) +
            "-";
          this.addNumberInfoProc();
        } else {
          this.editNumberInfoBySupplierTableProc();
        }
      }

      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
    },

    //新規
    addNumberInfoProc() {
      this.showFlag = true;

      //新規
      addNumberInfo({
        numberEditForm: this.numberEditForm,
        supplierTable: this.supplierTable,
        user: getUserInfo().UserId,
      })
        .then((res) => {
          this.numberEditForm.nbQuoteNo = res;
          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
          //新規⇒編集
          this.localIsAdd = false;

          //検索処理を行う
          this.searchNumberDetailByNbQuoteNoProc();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
          this.numberEditForm.nbQuoteNo = "";
        });
    },

    //仕入先見積依頼画面
    showNumberEditProcessingDialogProc() {
      if (this.oldSupplierTableData != this.getTableValue(this.supplierTable)) {
        //表データに変化がある場合
        Modal.showWarning("", t("message.NUMBER.DATA_SAVE_FIRST"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      } else if (this.supplierTable.length == 0) {
        Modal.showWarning("", t("message.NUMBER.PRODUCT_NONE"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      } else {
        ShowNumberEditProcessingDialog(
          {
            nbQuoteNo: this.numberEditForm.nbQuoteNo,
            nbProcKbn: this.numberEditForm.nbProcKbn,
            nbQuoteDate: this.numberEditForm.nbQuoteDate,
            productNotEditFlg: this.productNotEditFlg,
          },
          t("resource.NUMBER.SUPPLIER_ESTIMATE_VIEW"),
          (target) => {
            this.searchNumberDetailByNbQuoteNoProc();
          }
        );
      }

      // フォーカス削除
      this.$refs.showProcessingBtn.$el.blur();
    },

    //得意先見積画面
    showNumberEditCustomerDialogProc() {
      if (this.oldSupplierTableData != this.getTableValue(this.supplierTable)) {
        //表データに変化がある場合
        Modal.showWarning("", t("message.NUMBER.DATA_SAVE_FIRST"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      } else if (this.supplierTable.length == 0) {
        Modal.showWarning("", t("message.NUMBER.PRODUCT_NONE"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      } else if (!this.supplierCheckResult) {
        //仕入先がすべて選択されていない場合
        Modal.showWarning("", t("message.NUMBER.SUPPLIER_CHECK_FAIL"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      } else {
        ShowNumberEditCustomerDialog(
          {
            nbQuoteNo: this.numberEditForm.nbQuoteNo,
            nbProcKbn: this.numberEditForm.nbProcKbn,
            nbQuoteDate: this.numberEditForm.nbQuoteDate,
            productNotEditFlg: this.productNotEditFlg,
          },
          t("resource.NUMBER.CUSTOMER_ESTIMATE_VIEW"),
          (target) => {
            this.searchNumberDetailByNbQuoteNoProc();
          }
        );
      }
      // フォーカス削除
      this.$refs.showCustomerBtn.$el.blur();
    },

    //再度見積ボタン
    estimateAgainProc() {
      if (this.oldSupplierTableData != this.getTableValue(this.supplierTable)) {
        //表データに変化がある場合
        Modal.showWarning("", t("message.NUMBER.DATA_SAVE_FIRST"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      } else if (!this.supplierCheckResult) {
        //仕入先がすべて選択されていない場合
        Message.showError(t("message.NUMBER.SUPPLIER_CHECK_FAIL"));
      } else {
        //見積日
        this.numberEditForm.nbQuoteDate = getCurrentDate(new Date());
        //見積状態:新規
        this.numberEditForm.nbQuoteState = this.nbStatusList[0].value;
        //担当者
        this.numberEditForm.nbUserCode = getUserInfo().UserId;

        estimateAgain({
          nbQuoteNo: this.numberEditForm.nbQuoteNo,
          numberEditForm: this.numberEditForm,
          user: getUserInfo().UserId,
        })
          .then((res) => {
            this.showflag = true;
            //見積No.
            this.numberEditForm.nbQuoteNo = res;

            Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));

            //検索処理を行う
            this.searchNumberDetailByNbQuoteNoProc();
          })
          .catch((err) => {
            this.showFlag = false;
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
            }
          });
      }

      // フォーカス削除
      this.$refs.estimateAgainBtn.$el.blur();
    },

    //更新
    editNumberInfoBySupplierTableProc() {
      this.showFlag = true;
      editNumberInfo({
        numberEditForm: this.numberEditForm,
        supplierTable: this.supplierTable,
        user: getUserInfo().UserId,
        nbUpdateTime: this.nbUpdateTime,
        nbOrderState: this.productNotEditFlg
          ? NB_ORDER_STATE_ORDERED
          : NB_ORDER_STATE_NOT_ORDERED,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));

          //検索処理を行う
          this.searchNumberDetailByNbQuoteNoProc();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        });
    },

    //入力チェック
    inputCheck() {
      //得意先
      if (!this.numberEditForm.nbCusCode) {
        Modal.showWarning(
          "",
          t("resource.COMMON_CONSTANT.CUSTOMER") + t("message.select.hint"),
          {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          }
        );
        return false;
      }

      //得意先担当者
      if (!this.numberEditForm.nbCusUserCode) {
        Modal.showWarning(
          "",
          t("resource.NUMBER.CUS_USER") + t("message.select.hint"),
          {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          }
        );
        return false;
      }

      //製品情報はデータがある場合
      if (this.supplierTable.length > 0) {
        for (var index = 0; index < this.supplierTable.length; index++) {
          const row = this.supplierTable[index];
          //品名が空欄場合
          if (!row.ndProdName) {
            Modal.showWarning(
              "",
              t("resource.COMMON_CONSTANT.PRODUCT_NAME") +
                t("message.input.hint"),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            return false;
          }

          //数量が空欄場合
          if (!row.ndProdQuantity) {
            Modal.showWarning(
              "",
              t("resource.COMMON_CONSTANT.COUNT") + t("message.input.hint"),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            return false;
          }
        }
      } else {
        Modal.showWarning("", t("message.NUMBER.PRODUCT_NONE"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return false;
      }

      return true;
    },

    //担当者の省略字の取得
    getContraction(userCode) {
      for (var i = 0; i < this.userList.length; i++) {
        if (this.userList[i].UserId === userCode) {
          return this.userList[i].Contraction;
        }
      }
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      //受注済みの場合、製品編集不可
      if (this.productNotEditFlg) {
        return;
      }

      //編集可能の背景色
      return "bg-cell-editable";
    },

    //チェックボックスのクリック可能性
    getSelectable() {
      return !this.productNotEditFlg;
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      index = index + 1;

      if (index > this.supplierTable.length - 1) {
        this.$refs[`input${0}-${columnProp}`][0].focus();
      } else {
        this.$refs[`input${index}-${columnProp}`][0].focus();
      }
    },

    //ダイアログを閉じる
    onCancel() {
      if (
        (!this.localIsAdd &&
          !cmpBasicData(this.cmpBasicResult, this.numberEditForm)) ||
        !cmpDetailData(
          this.cmpDetailResult,
          this.getTableValue(this.supplierTable)
        ) ||
        (this.localIsAdd && this.supplierTable.length > 1) ||
        (this.localIsAdd &&
          this.supplierTable.length == 1 &&
          !cmpDetailData(
            this.cmpDetailResult,
            this.getTableValue(this.supplierTable)
          ))
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .el-table .current-row > td {
  background-color: #b2d8ff;
}
.el-form-item {
  margin-bottom: 5px;
}

.cell_input .el-input__inner {
  height: 25px !important;
  padding: 0 5px !important;
}
::v-deep
  .hide-header-checkbox
  .el-table__header
  .cell
  .el-checkbox
  .el-checkbox__inner {
  display: none;
}
</style>
